import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  paper: {
    padding: '0 0 25px',
    width: '920px',
    [theme.breakpoints.down('md')]: {
      width: 'unset'
    },
    [theme.breakpoints.down('xs')]: {
      margin: 5
    }
  },
  titleContainer: {
    color: 'rgb(255, 255, 255)',
    height: '80px',
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: 'rgb(48, 50, 107)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: '21px',
    textAlign: 'center',
    textTransform: 'capitalize'
  },
  subtitle: {
    color: 'rgb(0, 10, 18)',
    fontSize: '19px',
    fontWeight: 400,
    letterSpacing: '0.09px',
    lineHeight: '17px',
    textAlign: 'center',
    padding: '30px 0px',
    marginTop: 0,
    marginBottom: '1rem',
    [theme.breakpoints.down('md')]: {
      padding: '30px 10px'
    }
  },
  questionsContainer: {
    padding: '0 35px'
  },
  questionsLabel: {
    fontSize: '16px',
    transform: 'translate(0px, -8px)',
    transformOrigin: 'left top',
    color: 'rgb(69, 18, 149)',
    transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms'
  },
  gpaContainer: {
    marginTop: '15px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 35px'
  },
  gpaValueInputContainer: {
    width: '140px'
  },
  gpaGradeContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    height: '90px',
    paddingLeft: '35px'
  },
  radioButtonGroupRoot: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    height: '90px'
  },
  radioButtonLabelContainer: {
    color: '#451295',
    cursor: 'pointer'
  },
  radioButtonLabel: {
    color: '#451295',
    fontSize: '14px !important',
    userSelect: 'none'
  },
  radioButtonChecked: {
    color: '#3700d7 !important'
  }
}))
